window.locale = (window.locale || {});
window.languageLib = {};
window.docArchiveLanguageLib = {};
window.myStoriesLanguageLib = {};
window.generalLib = {};

window.isCrossOrigin = function () {
	try {
		return (!window.parent.location.hostname);
	} catch (e) {
		return true;
	}
}

window.locale.getTranslations = function (primarySelector, secondarySelector) {
    var libContent;

    // when content is shown in iframe (like cross table) - access via parent
    if (self !== top && !isCrossOrigin()) {

        libContent = (window.parent.$(primarySelector).val() != undefined)
            ? window.parent.$(primarySelector).val()
            : window.parent.$(secondarySelector).val()
    } else {
        libContent = ($(primarySelector).val() != undefined)
            ? $(primarySelector).val()
            : $(secondarySelector).val();
    }

    if (libContent)
        return JSON.parse(libContent);
    else
        console.log('Error occurred while fetching translations');
}

window.locale.isEmpty = function (languageLibrary) {
    var count = 0;
    $.each(languageLibrary, function (index, value) { count++; });

    return (count === 0);
}

window.locale.get = function (ref, reportType) {

    try {
        if (locale.isEmpty(languageLib))
            languageLib = locale.getTranslations('#LanguageLibray', '#ctl00_LanguageLibray');

        if (locale.isEmpty(docArchiveLanguageLib))
            docArchiveLanguageLib = locale.getTranslations('#DocArchiveLanguageLibrary', '#ctl00_DocArchiveLanguageLibrary');

        if (locale.isEmpty(myStoriesLanguageLib))
            myStoriesLanguageLib = locale.getTranslations('#MyStoriesLanguageLibrary', '#ctl00_MyStoriesLanguageLibrary');

        if (locale.isEmpty(generalLib))
            generalLib = locale.getTranslations('#GeneralLanguageLibrary', '#ctl00_GeneralLanguageLibrary');

        if (reportType === 3) {
            if (docArchiveLanguageLib != undefined && docArchiveLanguageLib[ref] != undefined)
                return docArchiveLanguageLib[ref];
        }
        else if (reportType == 4) {
            if (myStoriesLanguageLib != undefined && myStoriesLanguageLib[ref] != undefined)
                return myStoriesLanguageLib[ref];
        }
        else if (reportType === 0) {
            if (generalLib != undefined && generalLib[ref] != undefined)
                return generalLib[ref];
        }
        else {
            if (languageLib != undefined && languageLib[ref] != undefined)
                return languageLib[ref];
        }
    } catch (e) {
        return ref;
    }

    return ref;
}
